import { ApolloLink, Observable } from '@apollo/client'
import { OperationDefinitionNode } from 'graphql'
import { print } from 'graphql'

import { isDev } from '@/config/env'
import { emitGqlTrace } from '@/utils/graphqlDevTracer'

function getOperationType(link: ApolloLink | null): link is ApolloLink {
  return link !== null
}

// Only instantiated in DEV mode; exported as null in production so tree-shaking
// removes the entire module from the production bundle.
export const devGraphqlLink: ApolloLink | null = isDev
  ? new ApolloLink((operation, forward) => {
      const startTime = Date.now()

      const def = operation.query.definitions.find(
        (d): d is OperationDefinitionNode => d.kind === 'OperationDefinition'
      )
      const operationType = def?.operation ?? 'query'

      return new Observable((observer) => {
        const sub = forward(operation).subscribe({
          next: (result) => {
            emitGqlTrace({
              id: crypto.randomUUID(),
              operationName: operation.operationName ?? '(anonymous)',
              operationType,
              variables: operation.variables as Record<string, unknown>,
              query: print(operation.query),
              response: {
                data: result.data,
                errors: result.errors ? [...result.errors] : undefined,
              },
              durationMs: Date.now() - startTime,
              timestamp: new Date().toISOString(),
            })
            observer.next(result)
          },
          error: (err) => {
            emitGqlTrace({
              id: crypto.randomUUID(),
              operationName: operation.operationName ?? '(anonymous)',
              operationType,
              variables: operation.variables as Record<string, unknown>,
              query: print(operation.query),
              response: { errors: [err] },
              durationMs: Date.now() - startTime,
              timestamp: new Date().toISOString(),
            })
            observer.error(err)
          },
          complete: () => observer.complete(),
        })

        return () => sub.unsubscribe()
      })
    })
  : null

// Type guard kept for client.ts conditional spread
export { getOperationType as isDevGraphqlLinkActive }
